const _ = require("lodash");

const withCommas = function(num) {
	const commaRegex = /(\d)(?=(\d\d\d)+(?!\d))/g;
	const numString = "" + num;
	const decSplit = numString.split(".");
	decSplit[0] = decSplit[0].replace(commaRegex, "$1,");
	return decSplit.join(".");
};

const withCommasIndices = function(num, indices) {
	indices.sort((a, b) => a - b);

	const words = [];
	for (let i = 0; i < num.length; i++) {
		if (!isNaN(num[i]) || num[i] === ".") {
			const word = {word: "", index: i, length: 0, commas: []};
			while (i < num.length && (!isNaN(num[i]) || num[i] === ".")) {
				word.word += num[i];
				i++;
			}
			word.length = word.word.length;
			words.push(word);
		}
	}

	for (let i = 0; i < words.length; i++) {
		for (let j = words[i].length - 3; j > 0; j -= 3) {
			words[i].commas.push(j + words[i].index);
		}
		words[i].commas.sort((a, b) => a - b);
	}
	const commaIndices = [];

	for (let i = 0; i < words.length; i++) {
		for (let j = 0; j < words[i].commas.length; j++) {
			const ind = words[i].commas[j];
			commaIndices.push(ind);

			num = num.slice(0, ind) + "," + num.slice(ind);
			for (let k = j + 1; k < words[i].commas.length; k++) {
				words[i].commas[k]++;
			}
			for (let k = i + 1; k < words.length; k++) {
				words[k].index++;
				for (let l = 0; l < words[k].commas.length; l++) {
					words[k].commas[l]++;
				}
			}
		}
	}

	for (let i = 0; i < words.length; i++) {
		for (let j = 0; j < words[i].commas.length; j++) {
			for (let k = 0; k < indices.length; k++) {
				if (indices[k] >= words[i].commas[j]) {
					indices[k]++;
				}
			}
		}
	}

	for (let i = 0; i < commaIndices.length; i++) {
		if (
			indices.includes(commaIndices[i] - 1) &&
			indices.includes(commaIndices[i] + 1)
		) {
			indices.push(commaIndices[i]);
		}
	}

	indices.sort((a, b) => a - b);
	return [num, indices];
};

const timeToString = function(timeObj) {
	if (!timeObj.meridiem) {
		return timeObj.hour + ":" + timeObj.minute;
	} else {
		return timeObj.hour + ":" + timeObj.minute + timeObj.meridiem;
	}
};

const stringToTime = function(timeString) {
	let error = false;
	const timeRegex = /^([0-9]{1,2}):([0-9]{1,2})([a,p,A,P][m,M])$/;
	let timeParts = timeRegex.exec(timeString);
	if (!timeParts || !timeParts[0]) {
		error = true;
		const incompleteTimeRegex = /^([0-9]{0,2}):([0-9]{0,2})([a,p,A,P][m,M]|.{0})$/;
		timeParts = incompleteTimeRegex.exec(timeString);
		if (!timeParts || !timeParts[0]) {
			return {
				error: error,
				time: null,
			};
		}
	}
	const hour = timeParts[1];
	const minute = timeParts[2];
	const meridiem = timeParts[3].toUpperCase();
	return {
		error: error,
		time: {
			hour: hour,
			minute: minute,
			meridiem: meridiem,
		},
	};
};

const simpleTimeToString = function(timeObj) {
	return timeObj.hour + ":" + timeObj.minute;
};

const isMeridianTime = function(timeString) {
	const timeRegex = /^([0-9]{1,2}):([0-9]{1,2})([a,p,A,P][m,M])$/;
	return timeRegex.exec(timeString) !== null;
};

const stringToSimpleTime = function(timeString) {
	const simpleTimeRegex = /^([0-2]?[0-9]):([0-9]{2})$/;
	if (!timeString || !timeString.match(simpleTimeRegex)) {
		return {
			error:
				"The time must be of the form HH:MM or H:MM where H and M are digits 0-9.",
		};
	}
	const timeParts = /^([01]?[0-9]):([0-9]{2})$/.exec(timeString);
	const hour = parseInt(timeParts[1]);
	const minute = parseInt(timeParts[2]);
	if (hour === 0 || hour > 12 || minute >= 60) {
		return {
			error:
				"The time must have an hour value > 0 and <= 12 and a minute value < 60",
		};
	}
	return {
		error: false,
		hour,
		minute,
	};
};

const countZeros = function(x) {
	if (x === 0 || x % 10 !== 0) {
		return 0;
	}

	return 1 + this.countZeros(Math.floor(x / 10));
};

//Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
const sign = function(x) {
	x = +x; // convert to a number
	if (x === 0 || isNaN(x)) {
		return x;
	}
	return x > 0 ? 1 : -1;
};

//Finds median given an array of numbers.
const median = function(numbers) {
	if (!_.isArray(numbers) || !numbers.length) {
		return {error: "The argument must be a non-empty array."};
	}
	for (let i = 0; i < numbers.length; i++) {
		if (!_.isFinite(numbers[i])) {
			return {
				error:
					"The argument array must contain only numbers. Element " +
					(i + 1) +
					" is not a number.",
			};
		}
	}
	const sortedNumbers = _.sortBy(numbers);
	const lowMiddle = Math.floor((sortedNumbers.length - 1) / 2);
	const highMiddle = Math.ceil((sortedNumbers.length - 1) / 2);
	return (sortedNumbers[lowMiddle] + sortedNumbers[highMiddle]) / 2;
};

//Finds range given an array of numbers.
const range = function(numbers) {
	if (!_.isArray(numbers) || !numbers.length) {
		return {error: "The argument must be a non-empty array."};
	}
	for (let i = 0; i < numbers.length; i++) {
		if (!_.isFinite(numbers[i])) {
			return {
				error:
					"The argument array must contain only numbers. Element " +
					(i + 1) +
					" is not a number.",
			};
		}
	}
	const sortedNumbers = _.sortBy(numbers);
	return _.last(sortedNumbers) - sortedNumbers[0];
};

// Finds mode given an array of numbers.
// Returns:
// - null if there is no mode
// - a single number if there is exactly one mode
// - an array of numbers if there are multiple modes
const mode = function(numbers) {
	if (!_.isArray(numbers) || !numbers.length) {
		return {error: "The argument must be a non-empty array."};
	}
	const modeMap = {};
	let maxCount = 1;
	let modes = [];

	// Count occurrences and track the highest frequency
	_.each(numbers, num => {
		modeMap[num] = modeMap[num] ? modeMap[num] + 1 : 1;
		if (modeMap[num] > maxCount) {
			maxCount = modeMap[num];
			modes = [num];
		} else if (modeMap[num] === maxCount) {
			modes.push(num);
		}
	});

	// No mode if no number appears more than once
	if (maxCount === 1) {
		return null;
	}

	// Sort modes for consistent ordering
	modes.sort((a, b) => a - b);

	// Return single number if only one mode, array if multiple
	return modes.length === 1 ? modes[0] : modes;
};

// https://stackoverflow.com/questions/4467539/javascript-modulo-gives-a-negative-result-for-negative-numbers
const mod = function(n, m) {
	return ((n % m) + m) % m;
};

const READ_ONES = [
	"",
	"one",
	"two",
	"three",
	"four",
	"five",
	"six",
	"seven",
	"eight",
	"nine",
];

const ONES = [...READ_ONES];
ONES[0] = "zero";

const PLACE_ONES = [
	"zeroth",
	"first",
	"second",
	"third",
	"fourth",
	"fifth",
	"sixth",
	"seventh",
	"eighth",
	"ninth",
];
const TEENS = [
	"ten",
	"eleven",
	"twelve",
	"thirteen",
	"fourteen",
	"fifteen",
	"sixteen",
	"seventeen",
	"eighteen",
	"nineteen",
];
const TENS = [
	"",
	"ten",
	"twenty",
	"thirty",
	"forty",
	"fifty",
	"sixty",
	"seventy",
	"eighty",
	"ninety",
];
/**/
const TRIPLETS = ["", "thousand", "million", "billion"];

/**
 * Takes n, an integer represented by a string, and converts it to the latini
 * @param {boolean} place Whether this is a "place" or "denominator" i.e. to use
 *                        "first" and "second" over "one" and "two".
 * @returns {string} The string representation of the number. See testcases above for desired output.
 */
const toLatin = function(n, place = false) {
	// we assume N fits in an int
	const builder = [];
	let triplet = 0;
	if (place && Number(n) < 10) {
		return PLACE_ONES[n];
	}
	if (Number(n) === 0) {
		return "zero";
	}

	n = ("" + n).split("").filter(x => !isNaN(Number(x)));
	while (n.length && n[0] === "0") {
		n.shift();
	}

	// read each group of 3, and then provide the right value
	let rightmost = true;
	while (n.length) {
		// pop out the last 3 digits
		const fromIndex = Math.max(n.length - 3, 0);
		const lookAt = n.slice(fromIndex).map(x => Number(x));
		let hundreds;
		n.splice(fromIndex, 3);

		// remove leading 0s
		while (lookAt.length && lookAt[0] === 0) {
			lookAt.shift();
		}

		// put the right suffix for the triplet
		// ex. if we're looking at 123,456
		//                             ^^^
		// next loop, we check     123,456
		//                         ^^^
		// don't read a string of 3 0s (ex. 1,000,000)
		if (!lookAt.length) {
			triplet++;
			rightmost = false;
			continue;
		} else {
			builder.unshift(TRIPLETS[triplet]);
			triplet++;
		}

		// case n >= 100
		// then just read the hundreds place, the 1s place
		// case n >= 1000
		if (lookAt.length === 3) {
			hundreds = lookAt.shift();
		}
		// console.log(lookAt);

		// case: n < 10
		// just return ones
		if (lookAt.length === 1) {
			builder.unshift(READ_ONES[lookAt[0]]);
		} else if (lookAt.length === 2) {
			// case: n in the teens
			// just return the right value
			if (lookAt[0] === 1) {
				builder.unshift(TEENS[lookAt[1]]);
			} else {
				// assume 2 digit starting with a 0 is impossible
				// case: n >= 20
				// then just read the tens place, then the ones place
				if (place && rightmost && lookAt[1] !== 0) {
					builder.unshift(PLACE_ONES[lookAt[1]]);
				} else {
					builder.unshift(READ_ONES[lookAt[1]]);
				}
				builder.unshift(TENS[lookAt[0]]);
			}
		}

		if (hundreds) {
			builder.unshift("hundred");
			builder.unshift(READ_ONES[hundreds]);
		}
		rightmost = false;
	}
	const filtered = builder.filter(x => x.length);
	if (!place) {
		return filtered.join(" ");
	} else {
		// else place == true, add 'th' to the end if it makes sense
		if (!filtered.length) {
			return "";
		}
		const lastElement = filtered[filtered.length - 1];
		if (!PLACE_ONES.includes(lastElement)) {
			filtered.pop();
			// special grammatical situations when adding a th: ends with t, e, or y
			if (!TEENS.includes(lastElement) && /(y|t)$/.test(lastElement)) {
				filtered.push(
					lastElement
						// replace ending 'y' with 'ieth'
						.replace(/y$/, "ieth")
						// replace ending 't' with 'th'
						.replace(/(t|e)$/, "th")
				);
			} else {
				// replace ending 'veth' (ex. twelveth) with 'fth'
				filtered.push((lastElement + "th").replace(/veth(s)?$/, "fth"));
			}
		}
		return filtered.join(" ");
	}
};

const primesUpToOneThousand = new Set([
	2,
	3,
	5,
	7,
	11,
	13,
	17,
	19,
	23,
	29,
	31,
	37,
	41,
	43,
	47,
	53,
	59,
	61,
	67,
	71,
	73,
	79,
	83,
	89,
	97,
	101,
	103,
	107,
	109,
	113,
	127,
	131,
	137,
	139,
	149,
	151,
	157,
	163,
	167,
	173,
	179,
	181,
	191,
	193,
	197,
	199,
	211,
	223,
	227,
	229,
	233,
	239,
	241,
	251,
	257,
	263,
	269,
	271,
	277,
	281,
	283,
	293,
	307,
	311,
	313,
	317,
	331,
	337,
	347,
	349,
	353,
	359,
	367,
	373,
	379,
	383,
	389,
	397,
	401,
	409,
	419,
	421,
	431,
	433,
	439,
	443,
	449,
	457,
	461,
	463,
	467,
	479,
	487,
	491,
	499,
	503,
	509,
	521,
	523,
	541,
	547,
	557,
	563,
	569,
	571,
	577,
	587,
	593,
	599,
	601,
	607,
	613,
	617,
	619,
	631,
	641,
	643,
	647,
	653,
	659,
	661,
	673,
	677,
	683,
	691,
	701,
	709,
	719,
	727,
	733,
	739,
	743,
	751,
	757,
	761,
	769,
	773,
	787,
	797,
	809,
	811,
	821,
	823,
	827,
	829,
	839,
	853,
	857,
	859,
	863,
	877,
	881,
	883,
	887,
	907,
	911,
	919,
	929,
	937,
	941,
	947,
	953,
	967,
	971,
	977,
	983,
	991,
	997,
]);

module.exports = {
	withCommas,
	withCommasIndices,
	timeToString,
	stringToTime,
	simpleTimeToString,
	isMeridianTime,
	stringToSimpleTime,
	countZeros,
	sign,
	median,
	range,
	mode,
	mod,
	toLatin,
	ONES,
	primesUpToOneThousand,
};
